import { z } from "zod";
import { PublicIdSchema } from "./common";
import { DriverAttendance, Weather } from "./driver-attendance";

export const AdminAttendance = DriverAttendance.extend({
  driver_public_id: PublicIdSchema,
  driver_name: z.string(),
});

export const ListAdminAttendancesInput = z.object({
  driver_public_id: PublicIdSchema.optional(),
  from: z.iso.date().optional(),
  to: z.iso.date().optional(),
  limit: z.coerce.number().int().min(1).max(200).default(100),
});

/**
 * 整合 L-1: 退勤打刻忘れ等の是正 (管理者による勤怠代理修正)。
 * 退勤未打刻だと odometer_end が null のままで F29 支払距離 / F27 実距離が全件 null になるため、
 * 管理者 (admin / office_staff) が任意ドライバーの出退勤時刻・ODO・天候を修正できるようにする。
 * 指定フィールドのみ更新し (未指定=変更なし)、修正後に運転日報を再生成して距離を復元する。
 */
export const CorrectAttendanceInput = z.object({
  clock_in_at: z.iso.datetime({ offset: true }).optional(),
  clock_out_at: z.iso.datetime({ offset: true }).optional(),
  odometer_start: z.number().int().min(0).optional(),
  odometer_end: z.number().int().min(0).optional(),
  weather: Weather.optional(),
  notes: z.string().optional(),
});

export type AdminAttendanceDto = z.infer<typeof AdminAttendance>;
export type ListAdminAttendancesInputDto = z.infer<typeof ListAdminAttendancesInput>;
export type CorrectAttendanceInputDto = z.infer<typeof CorrectAttendanceInput>;
